import React, { useEffect } from 'react';
import { useLayout } from './LayoutContext';
import './ThemeWrapper.css'; // Asegúrate de tener un archivo CSS para los estilos

const ThemeWrapper = ({ children }) => {
  const { isDarkTheme } = useLayout();
  
  // Aplicar el tema de forma más agresiva
  useEffect(() => {
    try {
      // Aplicar al html (elemento raíz)
      document.documentElement.classList.toggle('dark-theme', isDarkTheme);
      
      // También aplicar al body para mayor seguridad
      document.body.classList.toggle('dark-theme', isDarkTheme);
      
      // Aplicar directamente algunos estilos críticos para debug
      if (isDarkTheme) {
        document.documentElement.style.setProperty('--background-primary', '#171717');
        document.documentElement.style.setProperty('--text-primary', '#f5f5f5');
      } else {
        document.documentElement.style.setProperty('--background-primary', '#ffffff');
        document.documentElement.style.setProperty('--text-primary', '#171717');
      }
      
    } catch (error) {
      console.error("Error al aplicar el tema:", error);
    }
  }, [isDarkTheme]);
  
  return (
    <div className={`theme-root ${isDarkTheme ? 'dark-theme' : 'light-theme'}`} 
         style={{
           minHeight: '100vh',
           backgroundColor: isDarkTheme ? '#171717' : '#ffffff',
           color: isDarkTheme ? '#f5f5f5' : '#171717',
         }}>
      {children}
    </div>
  );
};

export default ThemeWrapper;